import React from "react";
import "../css/finsummary.css";

const FinSummary = () => {
  return (
    <div className="fin-summary">
      <div className="heading">
        <p className="title">Financing Summary</p>
        <p className="application-id">Application ID: 3870097</p>
      </div>
      <div className="stats">
        <div className="stat-1">
          <p className="figure">25,000</p>
          <p className="stat-name">Loan Amount</p>
        </div>
        <div className="stat-2">
          <p className="figure">10,000</p>
          <p className="stat-name"> Already repaid</p>
        </div>
        <div className="stat-3">
          <p className="figure">15,000</p>
          <p className="stat-name">
            Remaining to <br /> be repaid
          </p>
        </div>
      </div>
    </div>
  );
};

export default FinSummary;
